<!-- @format -->

<shared-media-component-media
	*ngIf="data?.Scene7ImagePath || data?.visualAssets"
	[visualAssets]="data.visualAssets"
	[image]="data.Scene7ImagePath"
	[imageWidthParam]="'1200px'"
	[itemTitle]="data.headline ? data.headline : data.Subhead"
	[altText]="data?.altText"
	[prioritize]="true">
</shared-media-component-media>
<div
	*ngIf="data"
	[ngClass]="[data.cta.length > 1 ? 'multi-cta' : '']">
	<strong
		*ngIf="data?.badgeText && data?.badgeText !== 'na'"
		[innerHTML]="data?.badgeText"></strong>

	@if (data?.headline && data?.headline !== 'na') {
		<h2>{{ data.headline }}</h2>
	}

	<p
		*ngIf="data?.Subhead && data?.Subhead !== 'na'"
		[innerHTML]="data?.Subhead"></p>
	<span
		class="cta-container hmf-pr-m-xs"
		*ngFor="let cta of data.cta; trackBy: trackByDataCta">
		<button
			hmf-button
			*ngIf="cta && cta.link && cta.link !== 'na'"
			height="base"
			[variant]="buttonVariant"
			[href]="cta.link"
			[attr.altText]="cta.linkTitle"
			[attr.target]="targetService(cta.link)"
			[text]="cta.linkTitle"
			[dataEm]="createTag(spotNumber, data.headline, cta.linkTitle)"></button>
	</span>
</div>
